import { render, staticRenderFns } from "./EmpowerDetails.vue?vue&type=template&id=ada1a882&scoped=true&"
import script from "./EmpowerDetails.vue?vue&type=script&lang=js&"
export * from "./EmpowerDetails.vue?vue&type=script&lang=js&"
import style0 from "./EmpowerDetails.vue?vue&type=style&index=0&id=ada1a882&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada1a882",
  null
  
)

export default component.exports